export async function getNationalAddresses() {
  const endpoint = 'https://tfpv4risaf.execute-api.ap-southeast-1.amazonaws.com/prod/getNationalAddresses';
  try {
    const response = await fetch(endpoint);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching national addresses:', error);
    throw error;
  }
}
